import { callAuthorizedGraphQLEndpoint } from 'Module/graphQL'

export default async cityId => {
  const query = `query ($cityId:ID!) {
      city(id: $cityId){
        id
        recruitmentOnHold
        name
        timezone
        statusV2
        newcomersMissionsLimit
        cbdRadius
        surgeInterval
        pickupInformation
        morningCheckingTime
        morningCheckingTimeBefore
        morningCheckingTimeAfter
        lunchCheckingTime
        lunchCheckingTimeBefore
        lunchCheckingTimeAfter
        afternoonCheckingTime
        afternoonCheckingTimeBefore
        afternoonCheckingTimeAfter
        checkinRadius
        payHourly
        recruitmentCalendarId
        onboardingLocation
        onboardingUrl
        teamLeaderEnabled
        country {
          code
        }
        location {
          latitude
          longitude
        }
        spySettings {
          id
          cityId
          hourlyRate
          maxBudgetPerWeek
          travelAllowancePerMission
          travelAllowanceCap
          durationHandToHandMission
          durationLetterboxMission
          durationShift
          missionsPerShift
        }
      }
    }`
  return callAuthorizedGraphQLEndpoint(query, { cityId })
}



// WEBPACK FOOTER //
// ./src/Containers/Form/City/CityAddEdit/Edit/EditCityDetails/gql.js